module.exports = __webpack_public_path__ + "files/94562fe7ccda908212d03e637d88f203.svg";